import { useEffect, useState } from 'react';
import './AppSplash.css';

const DEFAULT_STATUSES = [
  'Connecting to workspace',
  'Verifying credentials',
  'Loading clients & tasks',
  'Syncing compliance calendar',
];

// Full-screen brand splash shown while the app boots (auth check / first load).
// Palette + type come from the design tokens, so it matches the app and adapts
// to dark mode. Copy is prop-driven with sensible defaults.
function AppSplash({
  mark = 'P',
  title = 'Practice',
  accent = 'Management',
  tagline = 'Compliance, tasks & clients — one workspace',
  footer = 'Secured workspace',
  statuses = DEFAULT_STATUSES,
}) {
  const [statusIdx, setStatusIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setStatusIdx((i) => (i + 1) % statuses.length), 1500);
    return () => clearInterval(id);
  }, [statuses.length]);

  return (
    <div className="ds-splash" role="status" aria-live="polite" aria-label="Loading">
      <div className="ds-splash-stage">
        <div className="ds-splash-mark"><span>{mark}</span></div>
        <h1 className="ds-splash-title">
          {title} <span className="ds-splash-accent">{accent}</span>
        </h1>
        <div className="ds-splash-tagline">{tagline}</div>
        <div className="ds-splash-modules" aria-hidden="true">
          <span /><span /><span /><span /><span />
        </div>
        <div className="ds-splash-status">{statuses[statusIdx]}</div>
      </div>
      <div className="ds-splash-footer">{footer}</div>
    </div>
  );
}

export default AppSplash;
